module.exports = __webpack_public_path__ + "static/art_2-9750ec03f97694453a2a87036c2f235d.jpg";